import { render } from "./index.vue?vue&type=template&id=c30e932e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c30e932e&lang=scss&scoped=true"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30e932e"]])

export default __exports__